export const locale = {
    lang: 'en',
    data: {
        TOOLBAR: {
            MY_PROFILE: 'My profile',
            PORTAL: 'Guidepost',
            LOGOUT: 'Logout',
        }
    }
};
